import React, { useState, useRef, useEffect } from 'react';
import Spline from '@splinetool/react-spline';

const fadeInUp = {
    animation: 'fadeInUp 0.6s cubic-bezier(0.23,1,0.32,1) 0.4s both',
};

const InteractiveRobot = () => {
    const [splineApp, setSplineApp] = useState(null);
    const splineContainerRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);

    function onSplineLoad(splineInstance) {
        setSplineApp(splineInstance);
        setIsLoading(false);
    }

    useEffect(() => {
        if (!splineApp || !splineContainerRef.current) return;

        const currentRef = splineContainerRef.current;

        const handleMouseMove = (event) => {
            const containerRect = currentRef.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left - containerRect.width / 2;
            const mouseY = event.clientY - containerRect.top - containerRect.height / 2;

            const headObject = splineApp.findObjectByName('RobotHead');
            if (headObject) {
                headObject.rotation.y = mouseX * 0.001;
                headObject.rotation.x = -mouseY * 0.001; // Negative for natural up/down
            }
        };

        // Add CSS to hide Spline watermark and add fadeInUp keyframes if not present
        const style = document.createElement('style');
        style.textContent = `
            .spline-watermark, 
            [data-name="spline-watermark"],
            canvas ~ a,
            canvas ~ div:last-child,
            a[href="https://spline.design"],
            div[class*="watermark"],
            div[class*="Watermark"] {
                display: none !important;
                opacity: 0 !important;
                visibility: hidden !important;
                pointer-events: none !important;
            }
            @keyframes fadeInUp {
                0% { opacity: 0; transform: translateY(40px); }
                100% { opacity: 1; transform: translateY(0); }
            }
        `;
        document.head.appendChild(style);

        currentRef.addEventListener('mousemove', handleMouseMove);

        // Clean up
        return () => {
            if (currentRef) {
                currentRef.removeEventListener('mousemove', handleMouseMove);
            }
            document.head.removeChild(style);
        };
    }, [splineApp]);

    // Scroll to #projects on click
    const handleExploreClick = () => {
        const el = document.getElementById('projects');
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <div
            ref={splineContainerRef}
            className="w-full h-[400px] md:h-[500px] flex flex-col items-center justify-end relative"
        >
            {isLoading && (
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-accentBlue"></div>
                </div>
            )}
            <Spline
                scene="https://prod.spline.design/hjEYGidAKvzMqOAI/scene.splinecode"
                onLoad={onSplineLoad}
                className="w-full h-full"
            />
            <button
                onClick={handleExploreClick}
                style={fadeInUp}
                className="mt-[-60px] w-full max-w-none rounded-none mx-auto
                  md:w-[600px] md:max-w-[600px] md:rounded-[12px]
                  z-20 bg-gradient-to-r from-[#4B006E] to-[#8A00D4] text-white font-display font-bold uppercase tracking-wider py-3 px-6
                  shadow-[0_0_20px_rgba(138,0,212,0.2)]
                  text-base md:text-lg flex items-center justify-center
                  transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-white/30
                  hover:scale-105 hover:ring-2 hover:ring-white/20 hover:text-white"
            >
                Explore My Works
            </button>
        </div>
    );
};

export default InteractiveRobot; 